import { render, staticRenderFns } from "./VPoppedAlert.vue?vue&type=template&id=216eb764&"
import script from "./VPoppedAlert.vue?vue&type=script&lang=ts&"
export * from "./VPoppedAlert.vue?vue&type=script&lang=ts&"
import style0 from "./VPoppedAlert.vue?vue&type=style&index=0&id=216eb764&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports